/**
 * Minimal complex-number arithmetic. Represented as plain { re, im } objects
 * rather than a class, since every quantum-engine function here only needs
 * to add/multiply/conjugate them — no need for operator overloading machinery.
 */

export const C = (re, im = 0) => ({ re, im });

export const cAdd = (a, b) => C(a.re + b.re, a.im + b.im);

export const cSub = (a, b) => C(a.re - b.re, a.im - b.im);

export const cMul = (a, b) => C(a.re * b.re - a.im * b.im, a.re * b.im + a.im * b.re);

export const cConj = (a) => C(a.re, -a.im);

export const cScale = (a, r) => C(a.re * r, a.im * r);

// |a|^2 — the Born-rule probability weight of an amplitude.
export const cAbs2 = (a) => a.re * a.re + a.im * a.im;

export const cAbs = (a) => Math.sqrt(cAbs2(a));

// e^{i*theta}, used to build phase gates (S, T, Rz, ...).
export const cExp = (theta) => C(Math.cos(theta), Math.sin(theta));

export const ZERO = C(0, 0);
export const ONE = C(1, 0);
export const I_UNIT = C(0, 1);
